import * as React from 'react';

import {
    Navbar,
    NavbarBrand,
    NavbarContent,
    NavbarItem,
    Link,
    NavbarMenuToggle,
    NavbarMenu, NavbarMenuItem, Dropdown, Button, DropdownTrigger, DropdownMenu, DropdownItem
} from "@nextui-org/react";
import logo from '../assets/logo.png';
import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {useNavigate} from "react-router-dom";
import {CalendarMonth, FavoriteRounded} from "@mui/icons-material";
import {FiChevronDown} from "@react-icons/all-files/fi/FiChevronDown";
import {CgPocket} from "@react-icons/all-files/cg/CgPocket";
import {FaFemale} from "@react-icons/all-files/fa/FaFemale";
import {FaMale} from "@react-icons/all-files/fa/FaMale";
import {MdSystemUpdate} from "@react-icons/all-files/md/MdSystemUpdate";
import {GiCapeArmor} from "@react-icons/all-files/gi/GiCapeArmor";


export default function NavbarComponent() {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    const navigate = useNavigate();


    const menuItems = [
        {
            "name": "Home",
            "route": "/"
        },
        {
            "name": "All Skins",
            "isDropDown": true,
            "children": [
                {
                    "name": "Latest Skins",
                    "route": "/skins",
                    "icon": <CalendarMonth size={35} style={{color: "#fca311"}}/>
                },
                {
                    "name": "Boys Skins",
                    "route": "/skins/boys",
                    "icon": <FaMale size={35} style={{color: "#0096c7"}}/>
                },
                {
                    "name": "Girls Skins",
                    "route": "/skins/girls",
                    "icon": <FaFemale size={35} style={{color: "#ffafcc"}}/>
                },
                {
                    "name": "Pocket Edition Skins",
                    "route": "/skins/pocketEdition",
                    "icon": <CgPocket size={35} style={{color: "#d4a373"}}/>
                }, {
                    "name": "Caves",
                    "route": "/skins/caves",
                    "icon": <GiCapeArmor size={35} style={{color: "#d4a373"}}/>
                },
                {
                    "name": "Most Downloaded Skins",
                    "route": "/skins/mostDownloaded",
                    "icon": <MdSystemUpdate size={35} style={{color: "#e63946"}}/>
                },
                {
                    "name": "Your Favourite",
                    "route": "/skins/favourite",
                    "icon": <FavoriteRounded size={35} style={{color: "#e63946"}}/>
                }
            ]
        },
        {
            "name": "Skin Viewer",
            "route": "/skinViewer"
        },
        {
            "name": "Contact Us",
            "route": "/contactus"
        }
    ];
    const {pathname} = useLocation();

    useEffect(() => {
        console.log(pathname);
    }, []);
    return (
        <Navbar onMenuOpenChange={setIsMenuOpen} isMenuOpen={isMenuOpen}>
            <NavbarContent>
                <NavbarMenuToggle
                    aria-label={isMenuOpen ? "Close menu" : "Open menu"}
                    className="sm:hidden"
                />
                <NavbarBrand>
                    <img className={'mr-1'} src={logo} alt={'Mincraft Skin Logo'} height={50} width={50}/>
                    <p className="font-bold text-inherit">MineCraft Skins</p>
                </NavbarBrand>
            </NavbarContent>
            <NavbarContent className="hidden sm:flex gap-4" justify="center">
                {
                    menuItems.map((value, index) => {
                        return (
                            (value.isDropDown ?? false
                            ) ? <Dropdown key={`desktop_dropDown ${index}`}>
                                <NavbarItem>
                                    <DropdownTrigger className={'p-0'}>
                                        <Button
                                            disableRipple
                                            className={pathname.includes("/skins") ? "text-success " : "text-foreground " + " bg-transparent data-[hover=true]:bg-transparent"}
                                            endContent={<FiChevronDown/>}
                                            radius="sm"
                                            variant="dark"
                                        >
                                            {value.name}
                                        </Button>
                                    </DropdownTrigger>
                                </NavbarItem>

                                <DropdownMenu
                                    aria-label="ACME features"
                                    className="w-[340px]"
                                    itemClasses={{
                                        base: "gap-4",
                                    }}
                                >
                                    {
                                        value.children.map((e) => {
                                            return <DropdownItem
                                                onClick={() => {
                                                    console.log(e.route);
                                                    setIsMenuOpen(false);
                                                    navigate(e.route);
                                                }}
                                                key="supreme_support"
                                                description={"Explore " + e.name + " Collection"}
                                                startContent={e.icon}
                                            >
                                                {e.name}
                                            </DropdownItem>;
                                        })
                                    }

                                </DropdownMenu>
                            </Dropdown> : <NavbarItem key={index}>

                                <Link color={value.route === pathname ? 'success' : "foreground"} href={value.route}>
                                    {
                                        value.name
                                    }
                                </Link>
                            </NavbarItem>
                        );
                    })
                }
            </NavbarContent>
            <NavbarContent justify="end">
            </NavbarContent>
            <NavbarMenu>
                {menuItems.map((item, index) => (
                    (item.isDropDown ?? false
                    ) ? <Dropdown  key={`mobile_dropDown ${index}`}>
                        <NavbarMenuItem>
                            <DropdownTrigger className={'p-0'}>
                                <Button
                                    disableRipple
                                    className={(pathname.includes("/skins") ? "text-success " : "text-foreground") + "text-small font-medium p-0 bg-transparent data-[hover=true]:bg-transparent"}
                                    endContent={<FiChevronDown/>}
                                    radius="sm"
                                    variant="dark"
                                >
                                    {item.name}
                                </Button>
                            </DropdownTrigger>
                        </NavbarMenuItem>

                        <DropdownMenu
                            aria-label="ACME features"
                            className="w-[340px]"
                            itemClasses={{
                                base: "gap-4",
                            }}
                        >
                            {
                                item.children.map((e) => {
                                    return <DropdownItem
                                        textValue={e.name}
                                        key={e.name +"_mobile"}
                                        description={"Explore " + e.name + " Collection"}
                                        startContent={e.icon}
                                    >
                                        <Link href={e.route}> {e.name}</Link>
                                    </DropdownItem>;
                                })
                            }

                        </DropdownMenu>
                    </Dropdown> : <NavbarMenuItem key={`${item}-${index}`}>
                        <Link
                            color={
                                item.route === pathname ? 'success' : "foreground"
                            }
                            className="w-full text-small font-medium"
                            href={item.route}
                            size="lg"
                        >
                            {item.name}
                        </Link>
                    </NavbarMenuItem>
                ))}
            </NavbarMenu>
        </Navbar>
    );
}